
  export default {
    data() {
      return {
        activeSlide: 0
      }
    },
    props: {
      blok: {
        type: Array,
        default: () => []
      }
    },
    mounted() {
      // console.log(this.blok)
    },
    methods: {
      scrollToSection(slug){
        if(slug){
          let offset = this.mobile ? -105 : -210
          let section = document.querySelector(`[data-category='${slug}'`)
          if(section){
            let y = section.getBoundingClientRect().top + offset
            window.scrollTo({
              top: y,
              behavior: "smooth"
            })
          } else {
            console.log("No section matches your slug")
          }
        }
        else {
          console.log("No slug present in storyblok component")
        }
      },
      previous() {
        if (this.activeSlide == this.slides.length-1) {
          this.activeSlide = 0
        }
      },
      next() {
        if (this.activeSlide < this.slides.length-1) {
          this.activeSlide = this.activeSlide+1
        }
      }
    },
    computed: {
      mobile() {
        return (this.$mq == 'sm' || this.$mq == 'md')
      },
      slides() {
        let slides = []

        if (this.blok && Array.isArray(this.blok)) {
          this.blok.forEach(component => {
            if (component.component == 'FeaturedBanner') {
              slides = component.slides
            }
          })
        }
        
        return slides
      },
      mobile() {
        return (this.$mq == 'sm' || this.$mq == 'md')
      }
    },
  }
